<template>
    <div>

        <!-- Start Blog Details Area -->
        <section class="blog-details-area ptb-80 mt-5">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 col-md-12">
                        <div class="blog-details-desc">
                            <div class="article-image">
                                <img src="../../../../assets/img/blog-image/4.jpg" alt="image">
                            </div>

                            <div class="article-content">
                                <div class="entry-meta">
                                    <ul>
                                        <li><feather type="clock"></feather> <a href="#">September 31, 2020</a></li>
                                        <li><feather type="user"></feather> <a href="#">Steven Smith</a></li>
                                    </ul>
                                </div>

                                <h3>Why does your business need digital marketing?</h3>

                                <p>Each business has a different set of goals to reach, but the main among them is always reach.Digital marketing can really be helpful for many small and large scale businesses, here is why you need digital marketing.</p>
                                <p>It is the most affordable means of marketing among all the marketing methods. Digital marketing has mobile access. Nowadays every person has a smartphone and digital marketing can take advantage of it to increase your business reach.</p>
                                <p>Digital marketing has mobile access. Nowadays every person has a smartphone and digital marketing can take advantage of it to increase your business reach.</p>
                                <p>There is a wide range of flexibility when you indulge yourself into digital marketing. There is content marketing, social media posts, blog posts and a wide range of possibilities for the future which can strategically increase your business reach to the upcoming youth.Nowadays many consumers do their purchases online. You can take advantage of this by feeling your business to them using digital marketing.</p>
                                <p>Nowadays many consumers do their purchases online. You can take advantage of this by feeling your business to them using digital marketing.</p>
                        </div>
                    </div>

                    
                </div>
                 <div class="col-lg-4 col-md-12">
                        <aside class="widget-area" id="secondary">
                            <section class="widget widget_search">
                                <form class="search-form">
                                    <label>
                                        <span class="screen-reader-text">Search for:</span>
                                        <input type="search" class="search-field" placeholder="Search...">
                                    </label>
                                    <button type="submit"><feather type="search"></feather></button>
                                </form>
                            </section>

                            <section class="widget widget_startp_posts_thumb">
                                <h3 class="widget-title">Popular Posts</h3>

                                <article class="item">
                                    <router-link to="/blog-details/WhyECommerce" class="thumb">
                                        <span class="fullimage cover bg1" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2021-06-30">June 10, 2021</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/WhyECommerce">How can eCommerce help your business?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>

                                <article class="item">
                                    <router-link to="/blog-details/NeedWebSide" class="thumb">
                                        <span class="fullimage cover bg2" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2021-06-30">June 21, 2021</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/NeedWebSide">Why does your business need a website?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>

                                <article class="item">
                                    <router-link to="/blog-details/NeedDigitalMarketing" class="thumb">
                                        <span class="fullimage cover bg3" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2021-06-30">June 30, 2021</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/NeedDigitalMarketing">Why does your business need digital marketing?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>
                                
                                <article class="item">
                                    <router-link to="/blog-details/WhyRestudent" class="thumb">
                                        <span class="fullimage cover bg4" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2021-06-30">June 30, 2021</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/WhyRestudent">Why does your restaurant need an online website?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>
                                
                                <article class="item">
                                    <router-link to="/blog-details/AppVsWeb" class="thumb">
                                        <span class="fullimage cover bg5" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2021-06-30">June 30, 2021</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/AppVsWeb">App vs Website: which one is better?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>
                                
                                <article class="item">
                                    <router-link to="/blog-details/NeedApps" class="thumb">
                                        <span class="fullimage cover bg6" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2021-06-30">June 30, 2021</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/NeedApps">Why does your business need an app?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>
                            </section>
                        </aside>
                    </div>
            </div>
            </div>
        </section>
        <!-- End Blog Details Area -->
    </div>
</template>

<script>
export default {
    name: 'NeedDigitalMarketing'
}
</script>